<template>
  <v-col v-if="store.add_to_social_media" :cols="12" :lg="9">
    <div class="bold-text mb-2">Post Review</div>
    <div class="d-flex ga-4">
      <template v-if="store.branches.length">
        <div
          v-for="branch in store.branches"
          :key="branch.id"
          class="post-review d-flex flex-column ga-3"
        >
          <div class="body d-flex justify-space-between align-center">
            <div class="branch d-flex align-center ga-2">
              <div class="position-relative">
                <img
                  class="circle-img"
                  :src="branch.image"
                  :alt="branch.name"
                />
                <img
                  class="position-absolute bottom-0 end-0"
                  width="16"
                  height="16"
                  :src="store?.platforms?.[0]?.image"
                  :alt="store?.platforms?.[0]?.name"
                />
              </div>
              <span>{{ branch.name }}</span>
            </div>
          </div>
          {{ store?.last_attachment }}
          <!-- <img
        :src="store?.last_attachment[0].file_path"
        class="rounded-sm"
        :alt="branch?.name"
      /> -->

          <div class="text">{{ store.caption || "No caption added yet" }}</div>
          <div class="footer">
            <div class="platforms d-flex ga-2">
              <v-icon
                v-for="platform in store.platforms"
                :key="platform.id"
                :icon="platform.icon"
                :color="platform.color"
                size="small"
              ></v-icon>
              <img :src="PostActions" alt="" />
            </div>
          </div>
        </div>
      </template>

      <div v-else class="no-branch-selected">
        Please select a branch to see the post review
      </div>
    </div>
  </v-col>
</template>

<script>
import { useEditTaskStore } from "@/store/editTaskStore";
import PostActions from "@/assets/images/post-actions.svg";
export default {
  name: "TaskPostReview",
  data() {
    return {
      store: useEditTaskStore(),
      PostActions,
    };
  },
};
</script>

<style scoped>
.no-branch-selected {
  color: #666;
  font-style: italic;
  padding: 1rem;
  text-align: center;
  background: #f5f5f5;
  border-radius: 8px;
}
</style>
